/* es5-ext/number/is-nan/index.js */ function _(require, module, exports) {
    module.exports = require(58) /* ./is-implemented */() ? Number.isNaN : require(59) /* ./shim */;
}
